import React from 'react'
import { Stack, Typography } from '@prometheus/components'
import { truncateCash } from '@prometheus/utils'
import PromiseButtonV2 from '@/components/PromiseButtonV2'
import { PopulationTierTarget } from './populationTier'

export interface PopulationQuickBuyProps {
  tier: PopulationTierTarget | null
  onQuickBuy: (quantity: number) => any
}

/**
 * One-click hire of exactly the headcount that pushes the ship into the next
 * population-growth band, however far off that band is. It only disappears
 * when there is no better band left to reach.
 */
export const PopulationQuickBuy = ({ tier, onQuickBuy }: PopulationQuickBuyProps) => {
  if (!tier) return null

  const blocked_by_capacity = !tier.withinCapacity
  const blocked_by_cash = !blocked_by_capacity && !tier.affordable

  return (
    <Stack space="xs">
      <PromiseButtonV2
        variant="secondary"
        disabled={blocked_by_capacity || blocked_by_cash}
        onClick={() => onQuickBuy(tier.needed)}
      >
        Hire {truncateCash(tier.needed, { raw: true })} &rarr; + {tier.nextGrowth} / year ({truncateCash(tier.cost)})
      </PromiseButtonV2>
      {blocked_by_capacity && (
        <Typography color="warning">
          Upgrade ship capacity to hold {truncateCash(tier.threshold, { raw: true })} population first.
        </Typography>
      )}
      {blocked_by_cash && (
        <Typography color="danger">
          Not enough cash — this hire costs {truncateCash(tier.cost)}.
        </Typography>
      )}
      {!blocked_by_capacity && !blocked_by_cash && (
        <Typography color="text-muted">
          Growth rises from + {tier.currentGrowth} to + {tier.nextGrowth} / year at {truncateCash(tier.threshold, { raw: true })} population.
        </Typography>
      )}
    </Stack>
  )
}

export default PopulationQuickBuy
